var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drill-report-score-chart-comp"},[_c('h2',[_vm._v(_vm._s(_vm.drillUnit.label)+"-时间图")]),_c('canvas',{ref:"chart",staticClass:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }